module.exports = __webpack_public_path__ + "img/img40.5444172b.png";